import React from "react";
import { Crumbs } from "./nav.jsx";

/**
 * Screen 6b (v1) — Sent confirmation (from the approved mockup). The push
 * succeeded: capture rows upserted, photos copied, the PDF added to the job's
 * files. Closes the loop — "Done — back to the job".
 */
export default function Sent({ nav, go }) {
  const { jobLabel, sent } = nav;
  const s = sent || {};
  return (
    <>
      <Crumbs
        trail={[
          { label: "Sheets", screen: "home", patch: { jobId: null } },
          { label: jobLabel, screen: "job" },
          { label: "Sent" },
        ]}
        go={go}
      />
      <div className="qhead">Sent to the job ✓<span className="d">{s.dayLabel ? `${s.dayLabel} — ` : ""}it's in this job now</span></div>

      <div className="card">
        <div className="togglerow">
          <span style={{ fontSize: 15 }}>✅</span>
          <span><b>{s.rowsWritten ?? 0} capture rows</b> → the job's capture list
            <div className="td">Upserted by capture — no duplicates, and any Suite edits stayed.</div>
          </span>
        </div>
        <div className="togglerow">
          <span style={{ fontSize: 15 }}>✅</span>
          <span><b>{s.photosUploaded ?? 0} photos</b> → job storage</span>
        </div>
        <div className="togglerow">
          <span style={{ fontSize: 15 }}>✅</span>
          <span><b>Contact sheet</b> → job files<div className="td">{s.pdfFile}</div></span>
        </div>
      </div>

      <div style={{ display: "flex", gap: 8, marginTop: 14, alignItems: "center" }}>
        <button type="button" className="btnP" onClick={() => go("job")}>Done — back to the job</button>
        <button type="button" className="btnS" onClick={() => go("home", { jobId: null, groupId: null })}>All jobs</button>
      </div>
    </>
  );
}
